import React from "react";
import { Form } from "formik";
import CobrandFields from '../Cobrands/CobrandFields';

const CobrandStep = ({ model }) => (
    <Form className="international-form">
        <CobrandFields model={model} />
    </Form>
);

export default CobrandStep;